import React, { Fragment } from 'react'
import { Trans } from 'react-i18next'
import { statusColors } from './CurrentTaskRow'
import Icon from '../../../common/SimpleComponents/Icon'
import {
  getCurrencySign,
  getFormattedCardPan
} from '../../../helpers/formatter'
import number from '../../../helpers/numberFormat'
import moment from 'moment'
import i18n from '../../../../i18n'

const chargeTypeKeys = {
  SHA: 'Transfers.RadioSHA',
  OUR: 'Transfers.RadioOUR',
  GUAR: 'Transfers.RadioGuar'
}

// Whether to show the transaction completion time
const hasLastUpdate = task =>
  ['Completed', 'Rejected'].includes(task.status) &&
  Boolean(task.lastUpdateDate)

const CurrentTaskDetailsInsurancePayment = ({ currentTask }) => {
  return (
    <>
      <div className="transaction-details-box">
        <div className="transaction-details-col-group">
          <div className="transaction-details-col-lable w-40">
            <Trans i18nKey="CurrentTasks.Amount" />:
          </div>
          <div className="transaction-details-col w-60">{`${number(
            currentTask.senderAmount
          )} ${getCurrencySign(currentTask.senderCurrency)}`}</div>
        </div>
      </div>

      <div className="transaction-details-box">
        <div className="transaction-details-col-group">
          <div className="transaction-details-col-lable w-40">
            <Trans i18nKey="CurrentTasks.RegistrationDate" />:
          </div>
          <div className="transaction-details-col w-60">
            {moment.unix(currentTask.regDate).format('DD MMM - YYYY HH:mm:ss')}
          </div>
        </div>
      </div>

      {hasLastUpdate(currentTask) && (
        <div className="transaction-details-box">
          <div className="transaction-details-col-group">
            <div className="transaction-details-col-lable w-40">
              <Trans i18nKey="CurrentTasks.lastUpdateDate" />:{' '}
            </div>
            <div className="transaction-details-col w-60">
              {moment
                .unix(currentTask.lastUpdateDate)
                .format('DD MMM - YYYY HH:mm:ss')}
            </div>
          </div>
        </div>
      )}

      {currentTask.fee > 0 && (
        <div className="transaction-details-box">
          <div className="transaction-details-col-group">
            <div className="transaction-details-col-lable w-40">
              <Trans i18nKey="CurrentTasks.Comission" />:
            </div>
            <div className="transaction-details-col w-60">{`${number(
              currentTask.fee
            )} ${getCurrencySign(currentTask.senderCurrency)}`}</div>
          </div>
        </div>
      )}

      <div className="transaction-details-box">
        <div className="transaction-details-col-group">
          <div className="transaction-details-col-lable w-40">
            <Trans i18nKey="CurrentTasks.FromAccount" />:
          </div>
          <div className="transaction-details-col w-60">
            {currentTask.senderAccountName
              ? currentTask.senderAccountName
              : `${currentTask.senderFirstName} ${currentTask.senderLastName}`}
            <br />
            {`${currentTask.senderIban} - ${getCurrencySign(
              currentTask.senderCurrency
            )}`}
          </div>
        </div>
      </div>
      <div className="transaction-details-box">
        <div className="transaction-details-col-group">
          <div className="transaction-details-col-lable w-40">
            <Trans i18nKey="CurrentTasks.ServiceName" />:
          </div>
          <div className="transaction-details-col w-60">{`${currentTask.providerName} ID: ${currentTask.identifier}`}</div>
        </div>
      </div>
    </>
  )
}

const CurrentTaskDetailsUtilityPayment = ({ currentTask }) => {
  return (
    <Fragment>
      <div className="transaction-details-box">
        <div className="transaction-details-col-group">
          <div className="transaction-details-col-lable w-40">
            <Trans i18nKey="CurrentTasks.Amount" />:
          </div>
          <div className="transaction-details-col w-60">{`${number(
            currentTask.senderAmount
          )} ${getCurrencySign(currentTask.senderCurrency)}`}</div>
        </div>
      </div>

      <div className="transaction-details-box">
        <div className="transaction-details-col-group">
          <div className="transaction-details-col-lable w-40">
            <Trans i18nKey="CurrentTasks.RegistrationDate" />:
          </div>
          <div className="transaction-details-col w-60">
            {moment.unix(currentTask.regDate).format('DD MMM - YYYY HH:mm:ss')}
          </div>
        </div>
      </div>

      {hasLastUpdate(currentTask) && (
        <div className="transaction-details-box">
          <div className="transaction-details-col-group">
            <div className="transaction-details-col-lable w-40">
              <Trans i18nKey="CurrentTasks.lastUpdateDate" />:{' '}
            </div>
            <div className="transaction-details-col w-60">
              {moment
                .unix(currentTask.lastUpdateDate)
                .format('DD MMM - YYYY HH:mm:ss')}
            </div>
          </div>
        </div>
      )}

      {currentTask.fee > 0 && (
        <div className="transaction-details-box">
          <div className="transaction-details-col-group">
            <div className="transaction-details-col-lable w-40">
              <Trans i18nKey="CurrentTasks.Comission" />:
            </div>
            <div className="transaction-details-col w-60">{`${number(
              currentTask.fee
            )} ${getCurrencySign(currentTask.senderCurrency)}`}</div>
          </div>
        </div>
      )}

      <div className="transaction-details-box">
        <div className="transaction-details-col-group">
          <div className="transaction-details-col-lable w-40">
            <Trans i18nKey="CurrentTasks.FromAccount" />:
          </div>
          <div className="transaction-details-col w-60">
            {currentTask.senderAccountName
              ? currentTask.senderAccountName
              : `${currentTask.senderFirstName} ${currentTask.senderLastName}`}
            <br />
            {`${currentTask.senderIban} - ${getCurrencySign(
              currentTask.senderCurrency
            )}`}
          </div>
        </div>
      </div>

      {currentTask.payType === 'MobileTopup' && currentTask.serviceName && (
        <div className="transaction-details-box">
          <div className="transaction-details-col-group">
            <div className="transaction-details-col-lable w-40">
              <Trans i18nKey="CurrentTasks.ServiceName" />:
            </div>
            <div className="transaction-details-col w-60">
              {currentTask.serviceName}
            </div>
          </div>
        </div>
      )}

      {currentTask.payType === 'Billing' && (
        <div className="transaction-details-box">
          <div className="transaction-details-col-group">
            <div className="transaction-details-col-lable w-40">
              <Trans i18nKey="CurrentTasks.ServiceName" />:
            </div>
            <div className="transaction-details-col w-60">{`${currentTask.providerName} ID: ${currentTask.identifier}`}</div>
          </div>
        </div>
      )}

      {currentTask.payType === 'MobileTopup' && (
        <div className="transaction-details-box">
          <div className="transaction-details-col-group">
            <div className="transaction-details-col-lable w-40">
              <Trans i18nKey="CurrentTasks.MobileNumber" />:
            </div>
            <div className="transaction-details-col w-60">
              {currentTask.identifier}
            </div>
          </div>
        </div>
      )}
      {currentTask.payType === 'MobileTopup' && (
        <div className="transaction-details-box">
          <div className="transaction-details-col-group">
            <div className="transaction-details-col-lable w-40">
              <Trans i18nKey="CurrentTasks.Operator" />:
            </div>
            <div className="transaction-details-col w-60">
              {currentTask.providerName}
            </div>
          </div>
        </div>
      )}

      {currentTask.payType === 'Penalty' && (
        <div className="transaction-details-box">
          <div className="transaction-details-col-group">
            <div className="transaction-details-col-lable w-40">
              <Trans i18nKey="CurrentTasks.PenaltyType" />:
            </div>
            <div className="transaction-details-col w-60">
              {currentTask.providerName}
            </div>
          </div>
        </div>
      )}

      {currentTask.payType === 'Penalty' && (
        <div className="transaction-details-box">
          <div className="transaction-details-col-group">
            <div className="transaction-details-col-lable w-40">
              <Trans i18nKey="CurrentTasks.PenaltyNumber" />:
            </div>
            <div className="transaction-details-col w-60">
              {currentTask.identifier}
            </div>
          </div>
        </div>
      )}
    </Fragment>
  )
}

const CurrentTaskDetailsNormal = ({ currentTask }) => {
  const isSpecRate = currentTask.exchangetype === 'SpecialRate'
  const specExchangeRate = isSpecRate
    ? currentTask.exchangeRate
    : currentTask.currentExchangeRate
  const specViewRate = isSpecRate
    ? currentTask.viewRate
    : currentTask.currentViewRate

  return (
    <Fragment>
      <div className="transaction-details-box">
        <div className="transaction-details-col-group">
          <div className="transaction-details-col-lable w-40">
            <Trans i18nKey="CurrentTasks.RegistrationDate" />:{' '}
          </div>
          <div className="transaction-details-col w-60">
            {moment.unix(currentTask.regDate).format('DD MMM - YYYY HH:mm:ss')}
          </div>
        </div>
      </div>
      {hasLastUpdate(currentTask) && (
        <div className="transaction-details-box">
          <div className="transaction-details-col-group">
            <div className="transaction-details-col-lable w-40">
              <Trans i18nKey="CurrentTasks.lastUpdateDate" />:{' '}
            </div>
            <div className="transaction-details-col w-60">
              {moment
                .unix(currentTask.lastUpdateDate)
                .format('DD MMM - YYYY HH:mm:ss')}
            </div>
          </div>
        </div>
      )}
      <div className="transaction-details-box">
        <div className="transaction-details-col-group">
          <div className="transaction-details-col-lable w-40">
            <Trans i18nKey="CurrentTasks.FromAccount" />:
          </div>
          <div className="transaction-details-col w-60">
            {currentTask.senderAccountName
              ? currentTask.senderAccountName
              : `${currentTask.senderFirstName} ${currentTask.senderLastName}`}
            <br />
            {`${currentTask.senderIban} - ${getCurrencySign(
              currentTask.senderCurrency
            )}`}
          </div>
        </div>
      </div>

      {currentTask.receiverIban && (
        <div className="transaction-details-box">
          <div className="transaction-details-col-group">
            <div className="transaction-details-col-lable w-40">
              <Trans i18nKey="CurrentTasks.ToAccount" />:
            </div>
            <div className="transaction-details-col w-60">
              {currentTask.receiverIban && (
                <div className="transaction-details-col">
                  {currentTask.receiverName}
                  <br />
                  {currentTask.receiverIban} -{' '}
                  {getCurrencySign(currentTask.receiverCurrency)}
                  {currentTask.receiverSwiftCode &&
                    currentTask.receiverSwiftCode}
                  {'/ '}
                  {currentTask.receiverBankName &&
                    currentTask.receiverBankName}{' '}
                  {currentTask.receiverBankCountry &&
                    currentTask.receiverBankCountry}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {currentTask.receiverINN && (
        <div className="transaction-details-box">
          <div className="transaction-details-col-group">
            <div className="transaction-details-col-lable w-40">
              <Trans i18nKey="CurrentTasks.ReceiverBank" />:
            </div>
            <div className="transaction-details-col w-60">{`${
              currentTask.receiverSwiftCode
            } / ${currentTask.receiverINN} / ${
              currentTask.receiverKPP ? currentTask.receiverKPP : ''
            } / ${currentTask.receiverBankAccount} / ${
              currentTask.receiverBankAddress
            }`}</div>
          </div>
        </div>
      )}
      {currentTask.intermediarySwiftCode && (
        <div className="transaction-details-box">
          <div className="transaction-details-col-group">
            <div className="transaction-details-col-lable w-40">
              <Trans i18nKey="CurrentTasks.Intermediary" />:
            </div>
            <div className="transaction-details-col w-60">{`${currentTask.intermediarySwiftCode} / ${currentTask.intermediaryBankName}`}</div>
          </div>
        </div>
      )}

      {currentTask.chargeType && (
        <div className="transaction-details-box">
          <div className="transaction-details-col-group">
            <div className="transaction-details-col-lable w-40">
              <Trans i18nKey="CurrentTasks.ChargeType" />:
            </div>
            <div className="transaction-details-col w-60">{`${i18n.t(
              chargeTypeKeys[currentTask.chargeType]
            )}`}</div>
          </div>
        </div>
      )}

      {(currentTask.taxPayerCode || currentTask.taxPayerDocNumber) &&
        currentTask.taxPayerName && (
          <div className="transaction-details-box">
            <div className="transaction-details-col-group">
              <div className="transaction-details-col-lable w-40">
                <Trans i18nKey="CurrentTasks.TaxPayer" />:
              </div>
              <div className="transaction-details-col w-60">
                {currentTask.taxPayerName}
                <br />
                {currentTask.taxPayerCode || currentTask.taxPayerDocNumber}
              </div>
            </div>
          </div>
        )}

      {currentTask.treasuryCode && (
        <div className="transaction-details-box">
          <div className="transaction-details-col-group">
            <div className="transaction-details-col-lable w-40">
              <Trans i18nKey="CurrentTasks.TreasuryCode" />:
            </div>
            <div className="transaction-details-col w-60">
              {currentTask.treasuryCode}
            </div>
          </div>
        </div>
      )}

      {currentTask.serviceName && (
        <div className="transaction-details-box">
          <div className="transaction-details-col-group">
            <div className="transaction-details-col-lable w-40">
              <Trans i18nKey="CurrentTasks.ServiceName" />:
            </div>
            <div className="transaction-details-col w-60">
              {currentTask.serviceName}
            </div>
          </div>
        </div>
      )}

      <div className="transaction-details-box">
        <div className="transaction-details-col-group">
          <div className="transaction-details-col-lable w-40">
            <Trans i18nKey="CurrentTasks.Amount" />:
          </div>
          <div className="transaction-details-col w-60">
            {/*{`${number(currentTask.senderAmount)} ${getCurrencySign(*/}
            {/*  currentTask.senderCurrency*/}
            {/*)}`}*/}
            {/*{currentTask.isConvert*/}
            {/*  ? ` = ${number(currentTask.receiverAmount)} ${getCurrencySign(*/}
            {/*      currentTask.receiverCurrency*/}
            {/*    )}`*/}
            {/*  : ''}*/}
            {`${number(
              currentTask.senderAmount || currentTask.receiverAmount
            )} ${getCurrencySign(
              currentTask.senderAmount
                ? currentTask.senderCurrency
                : currentTask.receiverCurrency
            )}`}
            {currentTask.isConvert &&
            currentTask.status !== 'WaitFxApproval' &&
            currentTask.status !== 'Rejected'
              ? ` = ${number(currentTask.receiverAmount)} ${getCurrencySign(
                  currentTask.receiverCurrency
                )}`
              : ''}
          </div>
        </div>
      </div>

      {currentTask.isConvert && !!specExchangeRate && (
        <div className="transaction-details-box">
          <div className="transaction-details-col-group">
            <div className="transaction-details-col-lable w-40">
              <Trans i18nKey="CurrentTasks.Course" />:
            </div>
            <div className="transaction-details-col w-60 fnt-b">
              {specExchangeRate > 1
                ? `1 ${getCurrencySign(currentTask.senderCurrency)} = ${number(
                    specViewRate,
                    4
                  )} ${getCurrencySign(currentTask.receiverCurrency)}`
                : `1 ${getCurrencySign(
                    currentTask.receiverCurrency
                  )} = ${number(specViewRate, 4)} ${getCurrencySign(
                    currentTask.senderCurrency
                  )}`}
            </div>
          </div>
        </div>
      )}

      {currentTask.isConvert &&
        isSpecRate &&
        currentTask.status !== 'WaitFxApproval' &&
        currentTask.status !== 'Rejected' &&
        !!currentTask.currentExchangeRate &&
        currentTask.currentExchangeRate !== currentTask.exchangeRate && (
          <div className="transaction-details-box">
            <div className="transaction-details-col-group">
              <div className="transaction-details-col-lable w-40">
                <Trans i18nKey="CurrentTasks.YourWin" />:
              </div>
              <div className="transaction-details-col w-60 fnt-b">
                {number(
                  currentTask.amountCurrency === currentTask.senderCurrency
                    ? currentTask.senderAmount *
                        (currentTask.exchangeRate -
                          currentTask.currentExchangeRate)
                    : currentTask.receiverAmount /
                        currentTask.currentExchangeRate -
                        currentTask.receiverAmount / currentTask.exchangeRate,
                  4
                )}{' '}
                {getCurrencySign(
                  currentTask.amountCurrency === currentTask.senderCurrency
                    ? currentTask.receiverCurrency
                    : currentTask.senderCurrency
                )}
              </div>
            </div>
          </div>
        )}

      {currentTask.fee !== 0 && (
        <div className="transaction-details-box">
          <div className="transaction-details-col-group">
            <div className="transaction-details-col-lable w-40">
              <Trans i18nKey="CurrentTasks.Comission" />:{' '}
            </div>
            <div className="transaction-details-col w-60">{`${number(
              currentTask.fee
            )} ${getCurrencySign(currentTask.senderCurrency)}`}</div>
          </div>
        </div>
      )}

      <div className="transaction-details-box">
        <div className="transaction-details-col-group">
          <div className="transaction-details-col-lable w-40">
            <Trans i18nKey="CurrentTasks.Purpose" />:
          </div>
          <div className="transaction-details-col w-60">
            {currentTask.description}
          </div>
        </div>
      </div>

      {currentTask.senderDocumentissuerCountryName && (
        <div className="transaction-details-box">
          <div className="transaction-details-col-group">
            <div className="transaction-details-col-lable w-40">
              <Trans i18nKey="CurrentTasks.SenderDocumentissuerCountryName" />:
            </div>
            <div className="transaction-details-col w-60">
              {currentTask.senderDocumentissuerCountryName}
            </div>
          </div>
        </div>
      )}

      {currentTask.additionalDescription && (
        <div className="transaction-details-box">
          <div className="transaction-details-col-group">
            <div className="transaction-details-col-lable w-40">
              <Trans i18nKey="CurrentTasks.AdditionalDescription" />:
            </div>
            <div className="transaction-details-col w-60">
              {currentTask.additionalDescription}
            </div>
          </div>
        </div>
      )}

      {currentTask.transferFiles && currentTask.transferFiles.length > 0 && (
        <div className="transaction-details-box">
          <div className="transaction-details-col-group">
            <div className="transaction-details-col-lable w-40">
              <Trans i18nKey="CurrentTasks.AttachedFile" />:
            </div>
            <div className="transaction-details-col w-60">
              {currentTask.transferFiles.map((file, ind) => {
                return <div key={ind}>{file.originalFileName}</div>
              })}
            </div>
          </div>
        </div>
      )}

      {currentTask.userComment && (
        <div className="transaction-details-box">
          <div className="transaction-details-col-group">
            <div className="transaction-details-col-lable w-40 flex-aligned">
              <Trans i18nKey="CurrentTasks.UserComment" />:
              <i className="icn icn-chat ml-5">
                <Icon name="icn-chat" viewBox="0 0 27 19.017" />
              </i>
            </div>
            <div className="transaction-details-col w-60">
              {currentTask.userComment}
            </div>
          </div>
        </div>
      )}

      {currentTask.moduleComment && (
        <div className="transaction-details-box">
          <div className="transaction-details-col-group">
            <div className="transaction-details-col-lable w-40 flex-aligned">
              <Trans i18nKey="CurrentTasks.ModuleComment" />:
              <i className="icn icn-chat ml-5">
                <Icon name="icn-chat" viewBox="0 0 27 19.017" />
              </i>
            </div>
            <div className="transaction-details-col w-60">
              {currentTask.moduleComment}
            </div>
          </div>
        </div>
      )}
    </Fragment>
  )
}

const CurrentTaskDetailsRemittance = ({ currentTask }) => {
  const isSend = currentTask.payType === 'RemittanceSend'

  return (
    <Fragment>
      <div className="transaction-details-box">
        <div className="transaction-details-col-group">
          <div className="transaction-details-col-lable w-40">
            <Trans
              i18nKey={`CurrentTasks.${isSend ? 'FromAccount' : 'ToAccount'}`}
            />
            :
          </div>
          <div className="transaction-details-col w-60">
            {currentTask.remittanceAccountName}{' '}
            {`${currentTask.remittanceAccountIban} - ${getCurrencySign(
              currentTask.remittanceAccountCurrency
            )}`}
          </div>
        </div>
      </div>

      <div className="transaction-details-box">
        <div className="transaction-details-col-group">
          <div className="transaction-details-col-lable w-40">
            <Trans i18nKey="CurrentTasks.Amount" />:
          </div>
          <div className="transaction-details-col w-60">
            {currentTask.remittanceAccountCurrency !==
              currentTask.remittanceCurrency &&
            currentTask.remittanceExchangeRate ? (
              <>
                {number(currentTask.remittanceAmount)}{' '}
                {getCurrencySign(currentTask.remittanceCurrency)} ={' '}
                <span>
                  {number(
                    (
                      currentTask.remittanceExchangeRate *
                      currentTask.remittanceAmount
                    ).toFixed(2)
                  )}{' '}
                  {getCurrencySign(currentTask.remittanceAccountCurrency)}
                </span>
              </>
            ) : (
              `${number(
                currentTask.remittanceAmount.toFixed(2)
              )} ${getCurrencySign(currentTask.remittanceCurrency)}`
            )}
          </div>
        </div>
      </div>
      {currentTask.remittanceAccountCurrency !==
        currentTask.remittanceCurrency &&
        currentTask.remittanceExchangeRate && (
          <div className="transaction-details-box">
            <div className="transaction-details-col-group">
              <div className="transaction-details-col-lable w-40">
                <Trans i18nKey="CurrentTasks.remittanceExchangeRate" />:
              </div>
              <div className="transaction-details-col w-60">
                {currentTask.remittanceExchangeRate < 1
                  ? `1 ${getCurrencySign(
                      currentTask.remittanceAccountCurrency
                    )} = ${(1 / currentTask.remittanceExchangeRate).toFixed(
                      4
                    )} ${getCurrencySign(currentTask.remittanceCurrency)}`
                  : `1 ${getCurrencySign(
                      currentTask.remittanceCurrency
                    )} = ${currentTask.remittanceExchangeRate.toFixed(
                      4
                    )} ${getCurrencySign(
                      currentTask.remittanceAccountCurrency
                    )}`}
              </div>
            </div>
          </div>
        )}

      {currentTask.remittanceProvider && (
        <div className="transaction-details-box">
          <div className="transaction-details-col-group">
            <div className="transaction-details-col-lable w-40">
              <Trans i18nKey="CurrentTasks.ServiceName" />:
            </div>
            <div className="transaction-details-col w-60">
              {currentTask.remittanceProvider}
            </div>
          </div>
        </div>
      )}

      {currentTask.remittanceCode && (
        <div className="transaction-details-box">
          <div className="transaction-details-col-group">
            <div className="transaction-details-col-lable w-40">
              <Trans i18nKey="CurrentTasks.RemittanceCode" />:
            </div>
            <div className="transaction-details-col w-60">
              {currentTask.remittanceCode}
            </div>
          </div>
        </div>
      )}

      {currentTask.remittanceCommission !== 0 && (
        <div className="transaction-details-box">
          <div className="transaction-details-col-group">
            <div className="transaction-details-col-lable w-40">
              <Trans i18nKey="CurrentTasks.Comission" />:{' '}
            </div>
            <div className="transaction-details-col w-60">{`${number(
              currentTask.remittanceCommission
            )} ${getCurrencySign(currentTask.remittanceCurrency)}`}</div>
          </div>
        </div>
      )}

      {currentTask.remittanceCountry && (
        <div className="transaction-details-box">
          <div className="transaction-details-col-group">
            <div className="transaction-details-col-lable w-40">
              <Trans i18nKey="CurrentTasks.Country" />:
            </div>
            <div className="transaction-details-col w-60">
              {currentTask.remittanceCountry}
            </div>
          </div>
        </div>
      )}
      {currentTask.remittanceState && (
        <div className="transaction-details-box">
          <div className="transaction-details-col-group">
            <div className="transaction-details-col-lable w-40">
              <Trans i18nKey="CurrentTasks.State" />:
            </div>
            <div className="transaction-details-col w-60">
              {currentTask.remittanceState}
            </div>
          </div>
        </div>
      )}

      {currentTask.remittanceCity && (
        <div className="transaction-details-box">
          <div className="transaction-details-col-group">
            <div className="transaction-details-col-lable w-40">
              <Trans i18nKey="CurrentTasks.City" />:
            </div>
            <div className="transaction-details-col w-60">
              {currentTask.remittanceCity}
            </div>
          </div>
        </div>
      )}

      {currentTask.remittanceFirstName && (
        <div className="transaction-details-box">
          <div className="transaction-details-col-group">
            <div className="transaction-details-col-lable w-40">
              <Trans i18nKey="CurrentTasks.ReceiverFirstName" />:
            </div>
            <div className="transaction-details-col w-60">
              {currentTask.remittanceFirstName}
            </div>
          </div>
        </div>
      )}

      {currentTask.remittanceLastName && (
        <div className="transaction-details-box">
          <div className="transaction-details-col-group">
            <div className="transaction-details-col-lable w-40">
              <Trans i18nKey="CurrentTasks.ReceiverLastName" />:
            </div>
            <div className="transaction-details-col w-60">
              {currentTask.remittanceLastName}
            </div>
          </div>
        </div>
      )}

      {currentTask.remittanceMiddleName && (
        <div className="transaction-details-box">
          <div className="transaction-details-col-group">
            <div className="transaction-details-col-lable w-40">
              <Trans i18nKey="CurrentTasks.ReceiverMiddleName" />:
            </div>
            <div className="transaction-details-col w-60">
              {currentTask.remittanceMiddleName}
            </div>
          </div>
        </div>
      )}

      {currentTask.remittancePhone && (
        <div className="transaction-details-box">
          <div className="transaction-details-col-group">
            <div className="transaction-details-col-lable w-40">
              <Trans i18nKey="CurrentTasks.ReceiverPhoneNumber" />:
            </div>
            <div className="transaction-details-col w-60">
              {currentTask.remittancePhone}
            </div>
          </div>
        </div>
      )}
      {currentTask.remittanceCreditInfoAgreed !== null && (
        <div className="transaction-details-box">
          <div className="transaction-details-col-group">
            <div className="transaction-details-col-lable w-40">
              <Trans i18nKey="MoneyTransfer.CreditInfoAgreed" />:
            </div>
            <div className="transaction-details-col w-60">
              <Trans
                i18nKey={`Common.${
                  currentTask.remittanceCreditInfoAgreed ? 'Yes' : 'No'
                }`}
              />
            </div>
          </div>
        </div>
      )}
    </Fragment>
  )
}

const CurrentTaskDetailsOpenTermDeposit = ({ currentTask }) => {
  return (
    <Fragment>
      <div className="transaction-details-box">
        <div className="transaction-details-col-group">
          <div className="transaction-details-col-lable w-40">
            <Trans i18nKey="CurrentTasks.TermDepositName" />:
          </div>
          <div className="transaction-details-col w-60">
            {currentTask.name ? currentTask.name : null}
            <br />
          </div>
        </div>
      </div>

      <div className="transaction-details-box">
        <div className="transaction-details-col-group">
          <div className="transaction-details-col-lable w-40">
            <Trans i18nKey="CurrentTasks.Amount" />:
          </div>
          <div className="transaction-details-col w-60">
            {currentTask.exchangeRate &&
            currentTask.senderAmount < currentTask.receiverAmount
              ? `${number(currentTask.amount)} ${getCurrencySign(
                  currentTask.currency
                )} = ${number(currentTask.senderAmount)} ${getCurrencySign(
                  currentTask.senderCurrency
                )}`
              : `${number(currentTask.amount)} ${getCurrencySign(
                  currentTask.currency
                )} ${
                  currentTask.exchangeRate
                    ? ` = ${number(currentTask.senderAmount)} ${getCurrencySign(
                        currentTask.senderCurrency
                      )}`
                    : ''
                }`}
          </div>
        </div>
      </div>

      <div className="transaction-details-box">
        <div className="transaction-details-col-group">
          <div className="transaction-details-col-lable w-40">
            <Trans i18nKey="CurrentTasks.RegistrationDate" />:{' '}
          </div>
          <div className="transaction-details-col w-60">
            {moment.unix(currentTask.regDate).format('DD MMM - YYYY HH:mm:ss')}
          </div>
        </div>
      </div>

      {hasLastUpdate(currentTask) && (
        <div className="transaction-details-box">
          <div className="transaction-details-col-group">
            <div className="transaction-details-col-lable w-40">
              <Trans i18nKey="CurrentTasks.lastUpdateDate" />:{' '}
            </div>
            <div className="transaction-details-col w-60">
              {moment
                .unix(currentTask.lastUpdateDate)
                .format('DD MMM - YYYY HH:mm:ss')}
            </div>
          </div>
        </div>
      )}

      {currentTask.exchangeRate ? (
        <div className="transaction-details-box">
          <div className="transaction-details-col-group">
            <div className="transaction-details-col-lable w-40">
              <Trans i18nKey="CurrentTasks.exchangeRate" />:
            </div>
            <div className="transaction-details-col w-60">
              {currentTask.senderAmount > currentTask.receiverAmount
                ? `1 ${getCurrencySign(currentTask.currency)} = ${(
                    currentTask.senderAmount / currentTask.receiverAmount
                  ).toFixed(4)} ${getCurrencySign(currentTask.senderCurrency)}`
                : `1 ${getCurrencySign(currentTask.senderCurrency)} = ${(
                    currentTask.receiverAmount / currentTask.senderAmount
                  ).toFixed(4)} ${getCurrencySign(currentTask.currency)}`}
              {/* {`1 ${getCurrencySign(currentTask.senderCurrency)} = ${currentTask.exchangeRate} ${getCurrencySign(currentTask.currency)}`} */}
            </div>
          </div>
        </div>
      ) : null}

      <div className="transaction-details-box">
        <div className="transaction-details-col-group">
          <div className="transaction-details-col-lable w-40">
            <Trans i18nKey="CurrentTasks.FromAccount" />:
          </div>
          <div className="transaction-details-col w-60">
            {currentTask.senderAccountName
              ? currentTask.senderAccountName
              : `${currentTask.senderFirstName} ${currentTask.senderLastName}`}
            <br />
            {`${currentTask.senderIban} - ${getCurrencySign(
              currentTask.senderCurrency
            )}`}
          </div>
        </div>
      </div>
    </Fragment>
  )
}

const CurrentTaskDetailsDepositAccumulative = ({ currentTask }) => {
  return (
    <Fragment>
      <div className="transaction-details-box">
        <div className="transaction-details-col-group">
          <div className="transaction-details-col-lable w-40">
            <Trans i18nKey="CurrentTasks.FromAccount" />:
          </div>
          <div className="transaction-details-col w-60">
            {currentTask.senderAccountName
              ? currentTask.senderAccountName
              : `${currentTask.senderFirstName} ${currentTask.senderLastName}`}
            <br />
            {`${currentTask.senderIban} - ${getCurrencySign(
              currentTask.senderCurrency
            )}`}
          </div>
        </div>
      </div>
      <div className="transaction-details-box">
        <div className="transaction-details-col-group">
          <div className="transaction-details-col-lable w-40">
            <Trans i18nKey="CurrentTasks.DepositName" />:
          </div>
          <div className="transaction-details-col w-60">
            {currentTask.receiverCurrency && (
              <div className="transaction-details-col">
                {currentTask.receiverName}&nbsp;
                {getCurrencySign(currentTask.receiverCurrency)}
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="transaction-details-box">
        <div className="transaction-details-col-group">
          <div className="transaction-details-col-lable w-40">
            <Trans i18nKey="CurrentTasks.Amount" />:
          </div>
          <div className="transaction-details-col w-60">
            {currentTask.senderCurrency != currentTask.receiverCurrency
              ? `${number(currentTask.senderAmount)} ${getCurrencySign(
                  currentTask.senderCurrency
                )} = ${number(currentTask.receiverAmount)} ${getCurrencySign(
                  currentTask.receiverCurrency
                )}`
              : ` ${number(currentTask.senderAmount)} ${getCurrencySign(
                  currentTask.senderCurrency
                )}`}
          </div>
        </div>
      </div>

      {currentTask.senderCurrency != currentTask.receiverCurrency ? (
        <div className="transaction-details-box">
          <div className="transaction-details-col-group">
            <div className="transaction-details-col-lable w-40">
              <Trans i18nKey="CurrentTasks.exchangeRate" />:
            </div>
            <div className="transaction-details-col w-60">
              {currentTask.senderAmount > currentTask.receiverAmount
                ? `1 ${getCurrencySign(currentTask.receiverCurrency)} = ${(
                    currentTask.senderAmount / currentTask.receiverAmount
                  ).toFixed(4)} ${getCurrencySign(currentTask.senderCurrency)}`
                : `1 ${getCurrencySign(currentTask.senderCurrency)} = ${(
                    currentTask.receiverAmount / currentTask.senderAmount
                  ).toFixed(4)} ${getCurrencySign(
                    currentTask.receiverCurrency
                  )}`}
            </div>
          </div>
        </div>
      ) : null}

      <div className="transaction-details-box">
        <div className="transaction-details-col-group">
          <div className="transaction-details-col-lable w-40">
            <Trans i18nKey="CurrentTasks.Purpose" />:
          </div>
          <div className="transaction-details-col w-60">
            {currentTask.description}
          </div>
        </div>
      </div>
    </Fragment>
  )
}

const CurrentTaskDetailsP2PTransfers = ({ currentTask }) => (
  <Fragment>
    <div className="transaction-details-box">
      <div className="transaction-details-col-group">
        <div className="transaction-details-col-lable w-40">
          <Trans i18nKey="CurrentTasks.RegistrationDate" />:{' '}
        </div>
        <div className="transaction-details-col w-60">
          {moment.unix(currentTask.regDate).format('DD MMM - YYYY HH:mm:ss')}
        </div>
      </div>
    </div>

    {hasLastUpdate(currentTask) && (
      <div className="transaction-details-box">
        <div className="transaction-details-col-group">
          <div className="transaction-details-col-lable w-40">
            <Trans i18nKey="CurrentTasks.lastUpdateDate" />:{' '}
          </div>
          <div className="transaction-details-col w-60">
            {moment
              .unix(currentTask.lastUpdateDate)
              .format('DD MMM - YYYY HH:mm:ss')}
          </div>
        </div>
      </div>
    )}

    <div className="transaction-details-box">
      <div className="transaction-details-col-group">
        <div className="transaction-details-col-lable w-40">
          <Trans i18nKey="CurrentTasks.FromCard" />:
        </div>
        <div className="transaction-details-col w-60">
          {getFormattedCardPan(currentTask.fromCard)}
        </div>
      </div>
    </div>
    <div className="transaction-details-box">
      <div className="transaction-details-col-group">
        <div className="transaction-details-col-lable w-40">
          <Trans i18nKey="CurrentTasks.ToCard" />:
        </div>
        <div className="transaction-details-col w-60">
          {getFormattedCardPan(currentTask.toCard)}
        </div>
      </div>
    </div>
    {currentTask.payType !== 'P2PTransfer' && (
      <div className="transaction-details-box">
        <div className="transaction-details-col-group">
          <div className="transaction-details-col-lable w-40">
            <Trans i18nKey="CurrentTasks.P2PReceiverName" />:
          </div>
          <div className="transaction-details-col w-60">
            {currentTask.receiverName}
          </div>
        </div>
      </div>
    )}

    <div className="transaction-details-box">
      <div className="transaction-details-col-group">
        <div className="transaction-details-col-lable w-40">
          <Trans i18nKey="CurrentTasks.Amount" />:
        </div>
        <div className="transaction-details-col w-60">
          {`${number(currentTask.senderAmount)} ${getCurrencySign(
            currentTask.senderCurrency
          )}`}
          {currentTask.isConvert
            ? ` = ${number(currentTask.receiverAmount)} ${getCurrencySign(
                currentTask.receiverCurrency
              )}`
            : ''}
        </div>
      </div>
    </div>

    {currentTask.isConvert && (
      <div className="transaction-details-box">
        <div className="transaction-details-col-group">
          <div className="transaction-details-col-lable w-40">
            <Trans i18nKey="CurrentTasks.Course" />:
          </div>
          <div className="transaction-details-col w-60 fnt-b">
            {currentTask.senderAmount < currentTask.receiverAmount
              ? `1 ${getCurrencySign(currentTask.senderCurrency)} = ${number(
                  currentTask.viewRate,
                  4
                )} ${getCurrencySign(currentTask.receiverCurrency)}`
              : `1 ${getCurrencySign(currentTask.receiverCurrency)} = ${number(
                  currentTask.viewRate,
                  4
                )} ${getCurrencySign(currentTask.senderCurrency)}`}
          </div>
        </div>
      </div>
    )}

    {currentTask.fee !== 0 && (
      <div className="transaction-details-box">
        <div className="transaction-details-col-group">
          <div className="transaction-details-col-lable w-40">
            <Trans i18nKey="CurrentTasks.Comission" />:{' '}
          </div>
          <div className="transaction-details-col w-60">{`${number(
            currentTask.fee
          )} ${getCurrencySign(currentTask.senderCurrency)}`}</div>
        </div>
      </div>
    )}
  </Fragment>
)

const CurrentTaskDetailsAutoComfortPayment = ({ currentTask }) => (
  <Fragment>
    {currentTask.amount != null && (
      <div className="transaction-details-box">
        <div className="transaction-details-col-group">
          <div className="transaction-details-col-lable w-40">
            <Trans i18nKey="CurrentTasks.Amount" />:
          </div>
          <div className="transaction-details-col w-60">
            {number(currentTask.amountGel)}{' '}
            {getCurrencySign(currentTask.senderCurrency)}
          </div>
        </div>
      </div>
    )}
    <div className="transaction-details-box">
      <div className="transaction-details-col-group">
        <div className="transaction-details-col-lable w-40">
          <Trans i18nKey="CurrentTasks.RegistrationDate" />:
        </div>
        <div className="transaction-details-col w-60">
          {moment.unix(currentTask.regDate).format('DD MMM - YYYY HH:mm:ss')}
        </div>
      </div>
    </div>

    {hasLastUpdate(currentTask) && (
      <div className="transaction-details-box">
        <div className="transaction-details-col-group">
          <div className="transaction-details-col-lable w-40">
            <Trans i18nKey="CurrentTasks.lastUpdateDate" />:{' '}
          </div>
          <div className="transaction-details-col w-60">
            {moment
              .unix(currentTask.lastUpdateDate)
              .format('DD MMM - YYYY HH:mm:ss')}
          </div>
        </div>
      </div>
    )}

    <div className="transaction-details-box">
      <div className="transaction-details-col-group">
        <div className="transaction-details-col-lable w-40">
          <Trans i18nKey="CurrentTasks.FromAccount" />:
        </div>
        <div className="transaction-details-col w-60">
          {currentTask.senderAccountName
            ? currentTask.senderAccountName
            : `${currentTask.senderFirstName} ${currentTask.senderLastName}`}
          <br />
          {`${currentTask.senderIban} - ${getCurrencySign(
            currentTask.senderCurrency
          )}`}
        </div>
      </div>
    </div>
    <div className="transaction-details-box">
      <div className="transaction-details-col-group">
        <div className="transaction-details-col-lable w-40">
          <Trans i18nKey="CurrentTasks.ServiceName" />:
        </div>
        <div className="transaction-details-col w-60">
          {currentTask.providerName}
        </div>
      </div>
    </div>
  </Fragment>
)

const currentTaskDetails = ({ currentTask, loading, error }) => {
  if (!currentTask) return null
  return (
    <Fragment>
      <div className="transaction-details flex">
        <div className="transaction-details-row">
          {(() => {
            switch (currentTask.payType) {
              case 'MobileTopup':
              case 'Penalty':
              case 'Billing':
                return (
                  <CurrentTaskDetailsUtilityPayment currentTask={currentTask} />
                )

              case 'RemittanceSend':
              case 'RemittanceReceive':
                return (
                  <CurrentTaskDetailsRemittance currentTask={currentTask} />
                )
              case 'DepositAccumulativeTopup':
                return (
                  <CurrentTaskDetailsDepositAccumulative
                    currentTask={currentTask}
                  />
                )
              case 'DepositAccumulativeRegistration':
              case 'DepositOpenTermRegistration':
                return (
                  <CurrentTaskDetailsOpenTermDeposit
                    currentTask={currentTask}
                  />
                )
              case 'P2PTransferByPan':
              case 'P2PTransfer':
                return (
                  <CurrentTaskDetailsP2PTransfers currentTask={currentTask} />
                )
              case 'Insurance':
                return (
                  <CurrentTaskDetailsInsurancePayment
                    currentTask={currentTask}
                  />
                )
              case 'AutoComfort':
                return (
                  <CurrentTaskDetailsAutoComfortPayment
                    currentTask={currentTask}
                  />
                )
              case 'C2ATransfer':
              case 'C2ATransferApplePayGPay':
                return <C2ACurrentTaskDetails currentTask={currentTask} />
              default:
                return <CurrentTaskDetailsNormal currentTask={currentTask} />
            }
          })()}
          <div className="transaction-details-box">
            <div className="transaction-details-col-group">
              <div className="transaction-details-col-lable w-40">
                <Trans i18nKey="CurrentTasks.Status" />:
              </div>
              <div className="transaction-details-col w-60 flex-aligned">
                {statusColors[currentTask.status] && (
                  <i
                    className={`icn mr-10  ${statusColors[currentTask.status]
                      .icon +
                      ' ' +
                      statusColors[currentTask.status].className}`}
                  >
                    <Icon
                      name={statusColors[currentTask.status].icon}
                      view={statusColors[currentTask.status].view}
                    />
                  </i>
                )}
                <span>
                  <Trans i18nKey={`Common.${currentTask.status}`} />
                </span>
              </div>
            </div>

            {currentTask.statusText && (
              <div className="transaction-details-col-group mt-12">
                <div className="transaction-details-col-lable w-40">
                  <Trans i18nKey="CurrentTasks.RejectReason" />:
                </div>
                <div className="transaction-details-col w-60 flex-aligned">
                  <span>{currentTask.statusText}</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </Fragment>
  )
}

const C2ACurrentTaskDetails = ({ currentTask }) => {
  return (
    <Fragment>
      {currentTask.fromCard && (
        <div className="transaction-details-box">
          <div className="transaction-details-col-group">
            <div className="transaction-details-col-lable w-40">
              <Trans i18nKey="CurrentTasks.FromCard" />:
            </div>
            <div className="transaction-details-col w-60">
              {currentTask.fromCard.trim() ||
                i18n.t(`CurrentTasks.${currentTask.subType}`)}
            </div>
          </div>
        </div>
      )}

      <div className="transaction-details-box">
        <div className="transaction-details-col-group">
          <div className="transaction-details-col-lable w-40">
            <Trans i18nKey="CurrentTasks.RegistrationDate" />:{' '}
          </div>
          <div className="transaction-details-col w-60">
            {moment.unix(currentTask.regDate).format('DD MMM - YYYY HH:mm:ss')}
          </div>
        </div>
      </div>
      {/* {hasLastUpdate(currentTask) && (
        <div className="transaction-details-box">
          <div className="transaction-details-col-group">
            <div className="transaction-details-col-lable w-40">
              <Trans i18nKey="CurrentTasks.lastUpdateDate" />:{' '}
            </div>
            <div className="transaction-details-col w-60">
              {moment
                .unix(currentTask.lastUpdateDate)
                .format('DD MMM - YYYY HH:mm:ss')}
            </div>
          </div>
        </div>
      )} */}

      {currentTask.receiverIban && (
        <div className="transaction-details-box">
          <div className="transaction-details-col-group">
            <div className="transaction-details-col-lable w-40">
              <Trans i18nKey="CurrentTasks.ToAccount" />:
            </div>
            <div className="transaction-details-col w-60">
              {currentTask.receiverIban && (
                <div className="transaction-details-col">
                  {currentTask.receiverIban}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      <div className="transaction-details-box">
        <div className="transaction-details-col-group">
          <div className="transaction-details-col-lable w-40">
            <Trans i18nKey="CurrentTasks.Amount" />:
          </div>
          <div className="transaction-details-col w-60">
            {`${number(currentTask.senderAmount)} ${getCurrencySign(
              currentTask.senderCurrency
            )}`}
            {currentTask.isConvert
              ? ` = ${number(currentTask.receiverAmount)} ${getCurrencySign(
                  currentTask.receiverCurrency
                )}`
              : ''}
          </div>
        </div>
      </div>

      {currentTask.isConvert && (
        <div className="transaction-details-box">
          <div className="transaction-details-col-group">
            <div className="transaction-details-col-lable w-40">
              <Trans i18nKey="CurrentTasks.Course" />:
            </div>
            <div className="transaction-details-col w-60 fnt-b">
              {currentTask.senderAmount < currentTask.receiverAmount
                ? `1 ${getCurrencySign(currentTask.senderCurrency)} = ${number(
                    currentTask.viewRate,
                    4
                  )} ${getCurrencySign(currentTask.receiverCurrency)}`
                : `1 ${getCurrencySign(
                    currentTask.receiverCurrency
                  )} = ${number(currentTask.viewRate, 4)} ${getCurrencySign(
                    currentTask.senderCurrency
                  )}`}
            </div>
          </div>
        </div>
      )}

      <div className="transaction-details-box">
        <div className="transaction-details-col-group">
          <div className="transaction-details-col-lable w-40">
            <Trans i18nKey="CurrentTasks.Comission" />:{' '}
          </div>
          <div className="transaction-details-col w-60">{`${number(
            currentTask.fee
          )} ${getCurrencySign(currentTask.senderCurrency)}`}</div>
        </div>
      </div>

      <div className="transaction-details-box">
        <div className="transaction-details-col-group">
          <div className="transaction-details-col-lable w-40">
            <Trans i18nKey="CurrentTasks.Sum" />:{' '}
          </div>
          <div className="transaction-details-col w-60">{`${number(
            currentTask.fee + currentTask.senderAmount
          )} ${getCurrencySign(currentTask.senderCurrency)}`}</div>
        </div>
      </div>

      {/* <div className="transaction-details-box">
        <div className="transaction-details-col-group">
          <div className="transaction-details-col-lable w-40">
            <Trans i18nKey="CurrentTasks.Purpose" />:
          </div>
          <div className="transaction-details-col w-60">
            {currentTask.description}
          </div>
        </div>
      </div> */}
    </Fragment>
  )
}

export default currentTaskDetails
